// Single source of truth for the tabs enabled in the Configuración drawer.
// Used by Settings.view.jsx and SettingsNavigation.js so both stay in sync.
// The channel profile editor tab lives in the Canales (/spaces) drawer — see
// utils/spacesTabs.js.

import { isConversationVisibilityUiEnabled } from "./conversationVisibility";

// `options.rolName`: role-gated tabs. "Visibilidad de conversaciones" is hidden
// while the configuration UI switch is off; when on, it is superadmin-only (the
// backend enforces that too: GET/PUT answer 403 FORBIDDEN).
// Partner access: a tab working a sede gets the same tabs, "Roles" included.
// The permissions the backend projects for the sede decide, as in a normal
// session, and the backend scopes roles to the sede's company.
export const getEnabledSettingsTabs = (permissions, options = {}) => {
  const perms = permissions || {};
  const tabs = [];

  if (perms.whatsappTemplate) tabs.push("whatsappTemplates");
  if (perms.readTags || perms.writeTags) tabs.push("tagsTab");
  if (perms.readRols || perms.writeRols) tabs.push("rolesTab");
  if (perms.readDataSheetConfiguration || perms.writeDataSheetConfiguration)
    tabs.push("dataSheetConfigurationTab");
  if (perms.readCompany || perms.writeCompany) {
    tabs.push("configTab");
    tabs.push("integrationsTab");
  }
  if (isConversationVisibilityUiEnabled() && options && options.rolName === "superadmin") {
    tabs.push("conversationVisibilityTab");
  }
  return tabs;
};

// Resolve which tab should be active: the requested tab when it is enabled,
// otherwise fall back to the first enabled tab. Keeps navigation state
// (e.g. location.state.openTab) from mounting a tab the user cannot access.
export const resolveActiveSettingsTab = (requestedTab, enabledTabs) => {
  const tabs = Array.isArray(enabledTabs) ? enabledTabs : [];
  return tabs.includes(requestedTab) ? requestedTab : tabs[0];
};
